import { render } from "./icon-reviewed-counter-2.svg?vue&type=template&id=470acd1b&scoped=true&component"
const script = {}

import "./icon-reviewed-counter-2.svg?vue&type=style&index=0&id=470acd1b&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470acd1b"]])

export default __exports__